/* eslint-disable no-unused-vars */
// import core & vendor packages below
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

// import components below
import Layout from 'components/Layout';
import PageHeader from './components/PageHeader';
import SideBar from 'components/ACLComponents/SideBar';
import RequestContainer from './components/RequestContainer';

// main component
const Request = () => {
  return (
    <Layout pageTitle='Request'>
      <PageHeader />
      <Row className='mt-4'>
        <Col sm={9}>
          <RequestContainer />
        </Col>
        <Col sm={3}>
          <SideBar />
        </Col>
      </Row>
    </Layout>
  );
};

export default Request;
